{
  "admin": {
    "title": "admin",
    "dashboard": "Dashboard",
    "clientsManagement": "Tenant Management",
    "usersManagement": "Users Management",
    "conversationOverview": "Conversation Overview",
    "aiManagement": "AI Management",
    "globalLogs": "Global Logs",
    "globalSettings": "Global Settings"
  },
  "manage": {
    "title": "manager",
    "dashboard": "Dashboard",
    "calendar": "Calendar",
    "tasksProjects": "Tasks & Projects",
    "knowledgeHub": "Knowledge Base",
    "videoMeetings": "Video Meetings",
    "communicationThreads": "Communication Threads",
    "leads": "Leads",
    "customers": "Customers",
    "reminders": "Reminders",
    "customersLeads": "Customers & Leads",
    "aiModules": "AI Automation Modules",
    "myCompany": "My Company",
    "resources": "Resources",
    "services": "Services",
    "employees": "Employees",
    "companiesAndEmployees": "Companies / Employees",
    "settings": "Settings",
    "booking": "Booking",
    "shop": "Shop",
    "permissions": "Permissions",
    "externalModules": "External Modules",
    "helpers": "Helpers"
  },
  "client": {
    "title": "client",
    "dashboard": "Dashboard",
    "myCalendar": "My Calendar",
    "communications": "Communications",
    "myProfile": "My Profile"
  }
}
